import { applicationMaintenanceSyncSlice } from './update';

export const { syncActionCreator: updateApplicationMaintenance } = applicationMaintenanceSyncSlice;
